import React, { useEffect, useState } from 'react'
import logo from '../images/logo.png'
import '../takeOffSheet.css'

// Add a global style for Times New Roman
const globalStyle = {
  fontFamily: 'Times New Roman, Times, serif !important'
};

function SheetTakeOff({elements, scale, company, jobsite, deliveryDate, contact, tel}) {

 
  return (
    <div
      className='wrapper-sheet bg-white p-[40px]'
      style={{
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${100 / scale}%`,
        height: `${100 / scale}%`,
        fontFamily: 'Times New Roman, Times, serif !important'
      }}
    >
    <div className='mx-auto' style={globalStyle}>
      <div id="header">
        <img src={logo} alt="Logo" />
        <div>
            <p> 10979 Olsen Road </p>
            <p> Surrey, BC </p>
            <p> V3V 3S9 </p>
            <p> Tel:(604) 800-9062 </p>
            <p> info@ttfscaffolding.com </p>
        </div>
      </div>

      <div className='flex flex-col my-[20px] contact-grid'>
        <div className='w-full grid grid-cols-[2fr_1fr] gap-[50px]'>
            <div className='grid grid-cols-[auto_3fr] items-center gap-0'>
                <p className='text-left w-fit'> CUSTOMER NAME: </p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> {company?.toUpperCase() ?? 'Company Name Goes Here'}</p>
            </div>
            <div className='grid grid-cols-[auto_2fr] items-center gap-0'>
                <p className='text-left w-fit'> DATE:</p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> {deliveryDate ? deliveryDate : "---"}</p>
            </div>
        </div>

        <div className='w-full grid grid-cols-[2fr_1fr] gap-[50px]'>
            <div className='grid grid-cols-[auto_3fr] items-center gap-0'>
                <p className='text-left w-fit'> JOBSITE: </p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> {jobsite?.toUpperCase() ?? 'Jobsite Goes Here'}</p>
            </div>
            <div className='grid grid-cols-[auto_2fr] items-center gap-0'>
                <p className='text-left w-fit'> ADDED VIA:</p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> ---- </p>
            </div>
        </div>

        <div className='w-full grid grid-cols-[1fr_1fr_1fr] gap-[20px]'>
            <div className='grid grid-cols-[auto_3fr] items-center gap-0'>
                <p className='text-left w-fit'> CONTACT NAME: </p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> {contact?.toUpperCase() ?? '---'}</p>
            </div>
            <div className='grid grid-cols-[auto_3fr] items-center gap-0'>
                <p className='text-left w-fit'> TEL: </p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> {tel?.toUpperCase() ?? '---'}</p>
            </div>
            <div className='grid grid-cols-[auto_2fr] items-center gap-0'>
                <p className='text-left w-fit'> RETURNED VIA:</p>
                <p className='border-b border-black p-0 w-full m-0 text-center contact-information'> ---- </p>
            </div>
        </div>

      </div>

      <div className='content'>
        <table>
          <thead>
            <tr>
              <th> DESCRIPTION </th>
              <th> ADD </th>
              <th> RET </th>
              <th> DESCRIPTION </th>
              <th> ADD </th>
              <th> RET </th>
            </tr>
          </thead>
          <tbody>
          <tr>
             <td className='description'> 6'H X 4'W ALUM H.D. FRAMES </td>
             <td className='quantity'> {elements.Frames_6Hx4W > 0 ? elements.Frames_6Hx4W : ""} </td>
             <td></td>
             <td className='description'> NO. 0 SHORES 3' - 4'6" (GREEN) </td>
             <td className='quantity'> {elements.sh03 > 0 ? elements.sh03 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 5'H X 4'W ALUM H.D. FRAMES </td>
             <td className='quantity'> {elements. Frames_5Hx4W > 0 ? elements. Frames_5Hx4W : ""} </td>
             <td></td>
             <td className='description'> NO. 0 SHORES 4' - 6'6" (SILVER)</td>
             <td className='quantity'> {elements.sh04 > 0 ? elements.sh04 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 4'H X 4'W ALUM H.D. FRAMES </td>
             <td className='quantity'> {elements.Frames_inBox > 0 ? elements.Frames_inBox : ""} </td>
             <td></td>
             <td className='description'> NO. 0 SHORES 3'9" - 6' (GREEN) </td>
             <td className='quantity'> {elements.sh039 > 0 ? elements.sh039 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 2'H X 4'W ALUM FRAMES (EXT)</td>
             <td className='quantity'> {elements.af2x4 > 0 ? elements.af2x4 : ""} </td>
             <td></td>
             <td className='description'> NO. 1 SHORES </td>
             <td className='quantity'> {elements.sh1 > 0 ? elements.sh1 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td></td>
             <td></td>
             <td></td>
             <td className='description'> NO. 1 SHORES (BLUE) </td>
             <td className='quantity'> {elements.sh1b > 0 ? elements.sh1b : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 6'H X 4' STEEL H.D. FRAMES </td>
             <td className='quantity'> {elements.Frames_6Hx4W > 0 ? elements.Frames_6Hx4W : ""} </td>
             <td></td>
             <td className='description'> NO. 2 SHORES  </td>
             <td className='quantity'> {elements.Shores > 0 ? elements.Shores : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 5'H X 4'W STEEL H.D. FRAMES </td>
             <td className='quantity'> {elements. Frames_5Hx4W > 0 ? elements. Frames_5Hx4W : ""} </td>
             <td></td>
             <td className='description'>  NO. 3 SHORES </td>
             <td className='quantity'> {elements.Shores_sub > 0 ? elements.Shores_sub : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> 4'H X 4'W STEEL H.D. FRAMES </td>
             <td className='quantity'> {elements.Frames_inBox > 0 ? elements.Frames_inBox : ""} </td>
             <td></td>
             <td className='description'> NO. 3 SHORES (BLUE) </td>
             <td className='quantity'> {elements.sh3b > 0 ? elements.sh3b : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 3'H X 4'W STEEL H.D. FRAMES </td>
             {/* <td className='description'> 3'H X 4'W STEEL H.D. FRAMES </td> */}
             <td className='quantity'> {elements.sf3x4 > 0 ? elements.sf3x4 : ""} </td>
             <td></td>
             <td className='description'> NO. 4 SHORES </td>
             <td className='quantity'> {elements.sh4 > 0 ? elements.sh4 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td></td>
             <td></td>
             <td></td>
             <td className='description'> NO. 4 SHORES (BLUE) </td>
             <td className='quantity'> {elements.sh4b > 0 ? elements.sh4b : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 10 X 4 C.BARS (PURPLE)</td>
             <td className='quantity'>{elements.cb10x4 > 0 ? elements.cb10x4 : ""} </td>
             <td></td>
             <td></td>
             <td></td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 10 X 2 C.BARS (PINK) </td>
             <td className='quantity'> {elements.cb10x2 > 0 ? elements.cb10x2 : ""} </td>
             <td></td>
             <td className='description'> 20'0" ALUM BEAMS (PURPLE) </td>
             <td className='quantity'> {elements.ab20 > 0 ? elements.ab20 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 7 X 4 C.BARS (YELLOW) </td>
             <td className='quantity'> {elements.cb7x4 > 0 ? elements.cb7x4 : ""} </td>
             <td></td>
             <td className='description'> 18'0" ALUM BEAMS (RED) </td>
             <td className='quantity'> {elements.ab18 > 0 ? elements.ab18 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 7 X 2 C.BARS (RED) </td>
             <td className='quantity'> {elements.cb7x2 > 0 ? elements.cb7x2 : ""} </td>
             <td></td>
             <td className='description'> 16'0" ALUM BEAMS (YELLOW) </td>
             <td className='quantity'> {elements.ab16 > 0 ? elements.ab16 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 5 X 4 C.BARS (GREEN) </td>
             <td className='quantity'> {elements.cb5x4 > 0 ? elements.cb5x4 : ""} </td>
             <td></td>
             <td className='description'> 14'0" ALUM BEAMS (SILVER) </td>
             <td className='quantity'> {elements.ab14 > 0 ? elements.ab14 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 5 X 2 C.BARS (ORANGE) </td>
             <td className='quantity'> {elements.cb5x2 > 0 ? elements.cb5x2 : ""} </td>
             <td></td>
             <td className='description'> 13'0" ALUM BEAMS (PINK) </td>
             <td className='quantity'> {elements.ab13 > 0 ? elements.ab13 : ""} </td>
             <td></td>
          </tr>
           <tr>
             <td className='description'> 4 X 4 C.BARS (BLUE) </td>
             <td className='quantity'> {elements.cb4x4 > 0 ? elements.cb4x4 : ""} </td>
             <td></td>
             <td className='description'> 12'0" ALUM BEAMS (BROWN) </td>
             <td className='quantity'> {elements.ab12 > 0 ? elements.ab12 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> 4 X 2 C.BARS (WHITE) </td>
             <td className='quantity'> {elements.cb4x2 > 0 ? elements.cb4x2 : ""} </td>
             <td></td>
             <td className='description'> 11'0" ALUM BEAMS (GREEN) </td>
             <td className='quantity'> {elements.ab11 > 0 ? elements.ab11 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td></td>
             <td></td>
             <td></td>
             <td className='description'> 10'6" ALUM BEAMS (BLUE)</td>
             <td> {elements.ab106 > 0 ? elements.ab106 : ""}</td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> ALUM H.D S.J U/HEADS </td>
             <td className='quantity'> {elements.U_Heads > 0 ? elements.U_Heads : ""} </td>
             <td></td>
             <td className='description'> 10'0" ALUM BEAMS (BLACK) </td>
             <td className='quantity'> {elements.ab10 > 0 ? elements.ab10 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> ALUM H.D. S.J. U/HEADS 40" </td>
             <td className='quantity'> {elements.auh40 > 0 ? elements.auh40 : ""} </td>
             <td></td>
             <td className='description'> 9'0" ALUM BEAMS (ORANGE) </td>
             <td className='quantity'> {elements.ab9 > 0 ? elements.ab9 : ""} </td>
             <td></td>
          </tr>
           <tr>
            <td className='description'> ALUM REGULAR HEADS </td>
             <td className='quantity'> {elements.auhreg > 0 ? elements.auhreg : ""} </td>
             <td></td>
             <td className='description'> 8'0" ALUM BEAMS (RED) </td>
             <td className='quantity'> {elements.ab8 > 0 ? elements.ab8 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> ALUM H.D. S.J. B/PLATES  </td>
             <td className='quantity'> {elements.Base_Plate > 0 ? elements.Base_Plate : ""} </td>
             <td></td>
             <td className='description'> 7'0" ALUM BEAMS (YELLOW) </td>
             <td className='quantity'> {elements.ab7 > 0 ? elements.ab7 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> ALUM H.D. S.J. B/PLATES 40"  </td>
             <td className='quantity'> {elements.abp40 > 0 ? elements.abp40 : ""} </td>
             <td></td>
             <td className='description'> 6'0" ALUM BEAMS (GREEN) </td>
             <td className='quantity'> {elements.ab6 > 0 ? elements.ab6 : ""} </td>
             <td></td>
            </tr>
           <tr>
             <td className='description'> ALUM REGULAR PLATES </td>
             <td className='quantity'> {elements.abpreg > 0 ? elements.abpreg : ""} </td>
             <td></td>
             <td className='description'> 5'0" ALUM BEAMS (WHITE) </td>
             <td className='quantity'> {elements.ab5 > 0 ? elements.ab5 : ""} </td>
             <td></td>
          </tr>
           <tr>
             <td></td>
             <td></td>
             <td></td>
             <td className='description'> 4'0" ALUM BEAMS (LIME GREEN) </td>
             <td className='quantity'> {elements.ab4 > 0 ? elements.ab4 : ""} </td>
             <td></td>
          </tr>
           <tr>
             <td className='description'> STEEL H.D. S.J. U/HEADS </td>
             <td className='quantity'> {elements.U_Heads > 0 ? elements.U_Heads : ""} </td>
             <td></td>
             <td></td>
             <td></td>
             <td></td>
           </tr>
           <tr>
             <td className='description'> STEEL H.D. S.J. U/HEADS 36" </td>
             <td className='quantity'> {elements.suh36 > 0 ? elements.suh36 : ""} </td>
             <td></td>
             <td className='description'> 14'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb14 > 0 ? elements.wb14 : ""} </td>
             <td></td>
            </tr>
          <tr>
             <td className='description'> STEEL H.D. S.J. U/HEADS 40"  </td>
             <td className='quantity'> {elements.suh40 > 0 ? elements.suh40 : ""} </td>
             <td></td>
             <td className='description'> 12'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb12 > 0 ? elements.wb12 : ""} </td>
             <td></td>
          </tr>
           
          <tr>
             <td className='description'> STEEL REGULAR HEADS </td>
             <td className='quantity'> {elements.suhreg > 0 ? elements.suhreg : ""} </td>
             <td></td>
             <td className='description'> 11'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb11 > 0 ? elements.wb11 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> STEEL H.D. S.J. B/PLATES </td>
             <td className='quantity'> {elements.Base_Plate > 0 ? elements.Base_Plate : ""} </td>
             <td></td>
             <td className='description'> 10'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb10 > 0 ? elements.wb10 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> STEEL H.D. S.J. B/PLATES 36"  </td>
             <td className='quantity'> {elements.sbp36 > 0 ? elements.sbp36 : ""} </td>
             <td></td>
             <td className='description'> 9'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb9 > 0 ? elements.wb9 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> STEEL H.D. S.J. B/PLATES 40"  </td>
             <td className='quantity'> {elements.sbp40 > 0 ? elements.sbp40 : ""} </td>
             <td></td>
             <td className='description'> 8'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb8 > 0 ? elements.wb8 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> STEEL REGULAR PLATES  </td>
             <td className='quantity'> {elements.sbpreg > 0 ? elements.sbpreg : ""} </td>
             <td></td>
             <td className='description'> 7'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb7 > 0 ? elements.wb7 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td></td>
             <td></td>
             <td></td>
             <td className='description'> 6'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb6 > 0 ? elements.wb6 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> ALUM H.D. FRAME COUPLING PINS </td>
             <td className='quantity'> {elements.afc > 0 ? elements.afc : ""} </td>
             <td></td>
             <td className='description'> 5'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb5 > 0 ? elements.wb5 : ""} </td>
             <td></td>
          </tr>

          <tr>
             <td className='description'> STEEL H.D. FRAME COUPLING PINS </td>
             <td className='quantity'> {elements.sfc > 0 ? elements.sfc : ""} </td>
             <td></td>
             <td className='description'> 4'0" 4X6 WOOD BEAMS </td>
             <td className='quantity'> {elements.wb4 > 0 ? elements.wb4 : ""} </td>
             <td></td>
          </tr>
          <tr>
             <td className='description'> BEAM CLIPS-REG    </td>
             <td className='quantity'> {elements.bc > 0 ? elements.bc : ""} </td>
             <td></td>
             <td className='description'> 4' X4' X 4' STEEL CAGE </td>
             <td className='quantity'> {elements.sc4x4x4 > 0 ? elements.sc4x4x4 : ""} </td>
             <td></td>
          </tr>
          <tr style={{display: elements.extra1 > 0 ? "":"none"}}> 
           <td className='description'> {elements.extraA}  </td>
           <td className='quantity'>  {elements.extra1 > 0 ? elements.extra1 : ""} </td>
           <td></td>
           <td className='description'> {elements.extraB}  </td>
           <td className='quantity'>  {elements.extra2 > 0 ? elements.extra2 : ""} </td>
           <td></td>
          </tr>
          <tr style={{display: elements.extra3 > 0 ? "":"none"}}> 
           <td className='description'> {elements.extraC}  </td>
           <td className='quantity'>  {elements.extra3 > 0 ? elements.extra3 : ""} </td>
           <td></td>
           <td className='description'> {elements.extraD}  </td>
           <td className='quantity'>  {elements.extra4 > 0 ? elements.extra4 : ""} </td>
           <td></td>
          </tr>
          <tr style={{display: elements.extra5 > 0 ? "":"none"}}> 
           <td className='description'> {elements.extraE}  </td>
           <td className='quantity'>  {elements.extra5 > 0 ? elements.extra5 : ""} </td>
           <td></td>
           <td className='description'> </td>
           <td> </td>
           <td></td>
          </tr>
          </tbody>
        </table>
        {/* <p id="totWeight"><b>Total Weight:</b> {totalWeight} lbs</p> */}
        
        {/* <div className='sign' style={{display: sign? "flex":"none"}}>
          <img src={sign}/>
          <p> Receipment </p>
        </div> */}
      </div>
    </div>

    </div>
  )
  
}

export default SheetTakeOff
